var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIsleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C21.732 0 28 6.26801 28 14H0C0 6.26801 6.26801 0 14 0Z",
    fill: "#F1564C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0002 4.0835C19.477 4.0835 23.9168 8.52334 23.9168 14.0002H4.0835C4.0835 8.52334 8.52334 4.0835 14.0002 4.0835Z",
    fill: "#FC8B46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 8.75C16.8995 8.75 19.25 11.1005 19.25 14H8.75C8.75 11.1005 11.1005 8.75 14 8.75Z",
    fill: "#FDBB53"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.13205 15.75H12.3023C12.7553 15.75 13.1226 16.119 13.1226 16.5742C13.1226 16.7552 13.0633 16.9312 12.9539 17.0749L7.13871 24.7161C6.82643 25.1265 6.24224 25.2047 5.83388 24.8909C5.76845 24.8407 5.70995 24.7819 5.65991 24.7161L0.230904 17.5824C-0.149681 17.0823 -0.0547501 16.3668 0.442938 15.9844C0.640801 15.8324 0.882963 15.75 1.13205 15.75Z",
    fill: "#2A3638"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6953 15.75H26.8656C27.4921 15.75 28 16.2604 28 16.8899C28 17.1402 27.918 17.3835 27.7667 17.5824L22.3377 24.7161C22.0254 25.1265 21.4412 25.2047 21.0329 24.8909C20.9674 24.8407 20.9089 24.7819 20.8589 24.7161L15.0437 17.0749C14.7685 16.7133 14.8372 16.196 15.197 15.9195C15.3401 15.8096 15.5152 15.75 15.6953 15.75Z",
    fill: "#2A3638"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.0835 15.75H23.9168L14.7849 27.6132C14.45 28.0482 13.8272 28.1283 13.3938 27.7922C13.327 27.7404 13.2671 27.6802 13.2155 27.6132L4.0835 15.75Z",
    fill: "#5F6257"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3335 15.75H18.6668L14.325 21.4232C14.1883 21.6017 13.9321 21.6362 13.7527 21.5002C13.7236 21.4781 13.6976 21.4522 13.6754 21.4232L9.3335 15.75Z",
    fill: "#919078"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsleIcon);
export default __webpack_public_path__ + "static/media/isle_icon.e03ae28f54ef5dbb9683e4ef6d2d1434.svg";
export { ForwardRef as ReactComponent };